// extracted by mini-css-extract-plugin
export var passChangeWrapper = "pass-change-module--pass-change-wrapper--XHjtS";
export var titleText = "pass-change-module--title-text--8x-5i";